module.exports = __webpack_public_path__ + "static/ui7-ed0507782da90664c45e627b4879907a.mp3";